import get from "lodash/get"
import { connect } from "react-redux"
import { withSpacing } from "hoc-lib/spacing"
import withSSRModel from "hoc-lib/ssrModelMapper"
import getLanguageRoute from "utils-lib/getLanguageRoute"
import { setCustomerAddress, setModalId } from "actions-lib"
import BreadcrumbHeader from "./BreadcrumbHeader"

export const mapDispatchToProps = {
  setCustomerAddress,
  setModalId,
}

const mapStateToProps = (state) => ({
  languageRoute: getLanguageRoute(get(state, `siteLanguage.language`, `en_CA`)),
  customerLob: get(state.customerSelections, `customerLob`),
  customerSearchedAddress: get(
    state.customerSelections,
    `customerSearchedAddress`,
  ),
  bottomMenuItems: get(state.aemData, `header.bottomMenuItems`, []),
  customerSelections: state.customerSelections,
  onlineProducts: state.onlineProducts,
})

const WrappedComponent = withSSRModel(
  connect(mapStateToProps, mapDispatchToProps)(withSpacing()(BreadcrumbHeader)),
)

// Component has to be mapped by the consumer
// Config has to be imported from constants-lib and passed to the MapTo function by the consumer
export default WrappedComponent
